<template>
    <div>
        <div id="upload-fail-alert" class="alert alert-danger mb-1" style="display: none;"></div>

        <div id="upload-success-alert" class="alert alert-success mb-1" style="display: none;"></div>

        <div class="enqUploadsContainer">
            <table class="table table-sm table-hover table-light table-bordered table-striped mb-0">
                <thead class="thead-dark">
                    <tr>
                        <th scope="col" style="width: 60%;">{{ __('File Name') }}</th>
                        <th scope="col">{{ __('File Size') }}</th>
                        <th scope="col">{{ __('Upload Date') }}</th>
                        <th scope="col">{{ __('Uploaded By') }}</th>

                        <th scope="col" style="width: 1%;"></th>
                    </tr>
                </thead>

                <tbody v-if="!uploads">
                    <tr>
                        <td colspan="5" class="enqUploadsEmpty py-2">{{ __('Loading...') }}</td>
                    </tr>
                </tbody>

                <tbody v-else-if="0 === uploads.length">
                    <tr>
                        <td
                            colspan="5"
                            class="enqUploadsEmpty py-1"
                        >{{ __('Be the first to upload a file below.') }}</td>
                    </tr>
                </tbody>

                <tbody v-else>
                    <!-- TODO: permissions for the below -->
                    <enq-upload
                        v-for="(upload, key) in uploads"
                        :key="key"
                        :index="key"
                        :url="upload.url"
                        :user="upload.user"
                        :file-name="upload.fileName"
                        :file-size="upload.fileSize"
                        :date-time="upload.dateTime"
                        :can-delete="!disabled"
                        :on-delete="onDelete"
                    ></enq-upload>
                </tbody>
            </table>

            <form autocomplete="off" enctype="multipart/form-data" novalidate>
                <div class="container d-flex flex-row input-group">
                    <div class="custom-file my-3">
                        <input
                            type="file"
                            class="form-control-file custom-file-input"
                            id="uploadFile"
                            @change="processFile($event.target.files[0])"
                            :disabled="disabled || saving"
                        >
                        <label
                            class="custom-file-label"
                            for="uploadFile"
                        >{{ initial ? __('Choose file') : file.name }}</label>
                    </div>

                    <button
                        type="button"
                        class="btn btn-primary upload-submit ml-3 mt-3"
                        :disabled="disabled || initial || saving"
                        @click.prevent="onSubmit"
                    >{{ __('Upload') }}</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    name: "EnqPortionUploads",

    props: {
        disabled: {
            required: true,
            type: Boolean,
        },
        enquiryId: {
            required: true,
            type: Number,
        },
    },

    data() {
        return {
            uploads: null,

            initial: true,
            saving: false,
            file: null,
        };
    },

    computed: {},

    methods: {
        onDelete(key) {
            let upload = this.uploads[key];

            axios
                .post("/api/enquiries/upload/delete", {
                    uploadID: upload.ID,
                })
                .then((response) => {
                    // console.log(response);

                    let data = response.data;
                    if (!data.success) {
                        $("#upload-fail-alert")
                            .text(data.message || "Unknown error")
                            .slideDown(200)
                            .delay(5000)
                            .slideUp(200);
                    } else {
                        for (let idx = 0; idx < this.uploads.length; idx++) {
                            const _upload = this.uploads[idx];

                            if (_upload.ID === upload.ID) {
                                this.uploads.splice(idx, 1);

                                return;
                            }
                        }
                    }
                })
                .catch((error) => {
                    console.error(error.response);

                    $("#upload-fail-alert")
                        .text(error.toString() || "Unknown error")
                        .slideDown(200)
                        .delay(5000)
                        .slideUp(200);
                });
        },

        onSubmit() {
            if (this.initial) {
                return;
            }

            this.saving = true;

            let formData = new FormData();
            formData.append("file", this.file);
            formData.append("enquiryID", this.enquiryId);

            axios
                .post("/api/enquiries/upload/submit", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((response) => {
                    // console.log(response);
                    this.saving = false;

                    let data = response.data;
                    if (!data.success) {
                        $("#upload-fail-alert")
                            .text(data.message || "Unknown error")
                            .slideDown(200)
                            .delay(5000)
                            .slideUp(200);
                    } else {
                        if (null === this.uploads) {
                            this.uploads = [];
                        }

                        this.uploads.splice(0, 0, data.upload);

                        $("#upload-success-alert")
                            .text(data.message || "Uploaded successfully!")
                            .slideDown(200)
                            .delay(8000)
                            .slideUp(200);

                        this.file = null;
                        this.initial = true;
                    }
                })
                .catch((error) => {
                    console.error(error.response);
                    this.saving = false;

                    $("#upload-fail-alert")
                        .text(error.toString() || "Unknown error")
                        .slideDown(200)
                        .delay(5000)
                        .slideUp(200);
                });
        },

        processFile(file) {
            this.initial = false;
            this.file = file;
        },
    },

    watch: {},

    mounted: function () {
        axios
            .post("/api/enquiries/upload/list", {
                enquiryID: this.enquiryId,
            })
            .then((response) => {
                // console.log(response);

                let data = response.data;
                if (!data.success) {
                    $("#upload-fail-alert")
                        .text(data.message || "Unknown error")
                        .slideDown(200)
                        .delay(5000)
                        .slideUp(200);
                } else {
                    this.uploads = data.uploads;

                    if (null === this.uploads) {
                        console.error(data);

                        $("#upload-fail-alert")
                            .text(data.message || "Unknown error")
                            .slideDown(200)
                            .delay(5000)
                            .slideUp(200);
                    }
                }
            })
            .catch((error) => {
                console.error(error.response);

                $("#upload-fail-alert")
                    .text(error.toString() || "Unknown error")
                    .slideDown(200)
                    .delay(5000)
                    .slideUp(200);
            });
    },
};
</script>
